export default "__VITE_ASSET__Cj5H6$Ax__"